import script from './descriptions-row.vue_vue_type_script_lang.mjs';
export { default } from './descriptions-row.vue_vue_type_script_lang.mjs';
import { render } from './descriptions-row.vue_vue_type_template_id_29b1db72_lang.mjs';

script.render = render;
script.__file = "packages/components/descriptions/src/descriptions-row.vue";
//# sourceMappingURL=descriptions-row.mjs.map
